import toaster from 'react-hot-toast';

import { CheckCircleIcon, CloseIcon } from '@/assets/icons';
import { mergeClasses } from '@/utils';

import { ICustomSuccessToast } from './Alert.interfaces';
import styles from './Alert.module.css';

const ToastSuccess: React.FC<ICustomSuccessToast> = ({ message, t }: ICustomSuccessToast) => {
  return (
    <div
      className={mergeClasses(
        // Base classes
        'font-semibold text-sm max-w-[550px] flex items-center bg-semantic-success-base rounded-soft p-base text-white',
        // State-based classes
        t.visible ? styles['animate-enter'] : styles['animate-leave'],
      )}
    >
      <div className="mr-s-plus">
        <CheckCircleIcon />
      </div>
      <div className="mr-m break-normal">{message}</div>
      <button onClick={() => toaster.dismiss(t.id)}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default ToastSuccess;
